import { AdminDashboardDataFilterV2, AdminDashboardNewUserStaticsResponse } from '../../graphql/API';
import { adminGetDashboardNewUsersData } from '../../graphql/queries';
import { executeGql, processGqlResult } from '../../utils/gql-utils';

export const adminGetDashboardNewUsersDataApi = async (
  filter: AdminDashboardDataFilterV2,
): Promise<AdminDashboardNewUserStaticsResponse> => {
  const result = await executeGql(adminGetDashboardNewUsersData, { filter });
  return processGqlResult<AdminDashboardNewUserStaticsResponse>(
    'adminGetDashboardNewUsersData',
    result,
  );
};
